import { ReactNode } from 'react'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Tab } from '@mui/material'
import { LoadingIndicator } from '@ui/feedback'
import { tabConfig } from './constants'

type Tabs = keyof typeof tabConfig

interface Props {
  isLoading?: boolean
  userList: ReactNode
  organisationList: ReactNode
  tokenSpendDashboard: ReactNode
  activeTab?: Tabs
  setActiveTab: (tab: Tabs) => void
}

const UserManagerTabs = ({
  isLoading = false,
  userList,
  organisationList,
  tokenSpendDashboard,
  activeTab,
  setActiveTab,
}: Props) => {
  if (isLoading) {
    return <LoadingIndicator />
  }

  return (
    <TabContext value={activeTab || tabConfig.users.value}>
      <TabList onChange={(_, value) => setActiveTab(value)} centered>
        <Tab
          {...tabConfig.users}
          sx={{ backgroundColor: '#fff', borderTopLeftRadius: 8 }}
          data-cy="tab-users"
        />
        <Tab
          {...tabConfig.organisations}
          sx={{ backgroundColor: '#fff' }}
          data-cy="tab-organisations"
        />
        <Tab
          {...tabConfig.tokenSpend}
          sx={{ backgroundColor: '#fff', borderTopRightRadius: 8 }}
          data-cy="tab-token-spend"
        />
      </TabList>
      <TabPanel value={tabConfig.users.value}>{userList}</TabPanel>
      <TabPanel value={tabConfig.organisations.value}>{organisationList}</TabPanel>
      <TabPanel value={tabConfig.tokenSpend.value}>{tokenSpendDashboard}</TabPanel>
    </TabContext>
  )
}

export default UserManagerTabs
